import { render, staticRenderFns } from "./DecoContest.vue?vue&type=template&id=1acafbcf&"
import script from "./DecoContest.vue?vue&type=script&lang=ts&"
export * from "./DecoContest.vue?vue&type=script&lang=ts&"
import style0 from "./DecoContest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports